import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, connect, ConnectedProps, useSelector } from 'react-redux';
import styles from './UpdateEmpresa.module.scss';
import Modal from 'Components/UI/Modal';
import Button from 'Components/UI/Button';
import Form from 'Components/UI/Form/Form';
import Field from 'Components/UI/Field';
import { Icon } from 'Components/UI';
import UploadAvatar from 'Components/UI/UploadAvatar';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import schema from './updateEmpresa.schema';
import Tabs from 'Components/UI/Tabs/Tabs';
import {
  stringToPhone,
  stringToCPF,
  stringToCNPJ,
  cleanMask,
  stringToCEP
} from 'Utils/MaskUtils';
import { Row, Col } from 'antd';
import { IGlobalReducerState } from 'Store/Base/interface/IGlobalReducerState';
import { MinhaContaActions } from 'Store/MinhaConta/MinhaConta.actions';
import { IUpdateUserCompanyDataRequest } from 'Data/interfaces/MinhaConta/IUpdateUserCompanyDataRequest';
import { IUserInforResponse } from 'Data/interfaces/Auth/IUserInfoResponse';
import PlanoAvisoPersonalizationUpgrade from 'Static/images/plano-aviso-personalization-upgrade.png';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { Mixpanel } from 'Utils/MixPanel';
import { Wrapper } from './styles';
import { getCurrentTenant, getTenants } from 'Store/Tenant/Tenant.selector';
import { useNavigate } from 'react-router';

interface IModal {
  visible?: boolean;
  onCancel?: () => void;
  onConfirm?: (value: boolean) => void;
  isLoading?: boolean;
  userInfos: IUserInforResponse | undefined;
}

const UpdateEmpresa: FC<Props> = (props) => {
  const { t } = useTranslation('minhaConta');
  const whatsappContactLinkFlag = useFeatureFlag('whatsapp-contact-link');
  const whatsappContactLink = (whatsappContactLinkFlag.enabled && typeof whatsappContactLinkFlag.value === 'string')
    ? whatsappContactLinkFlag.value
    : (process.env.REACT_APP_CONTACT_LINK || '');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tenants = useSelector(getTenants);
  const currentTenant = useSelector(getCurrentTenant);

  const userRole = props.userInfo?.CurrentRoleFk;
  const isAdmin = userRole === 1;
  const planOrder = props?.userInfo?.UserStoreItem?.StorePlan?.Order;
  const isStart = (planOrder || 0) <= 1;
  const isEnterprise = planOrder && (planOrder >= 4);

  const [tabSelected, setTabSelected] = useState('0');
  const [isSubmited, setIsSubmited] = useState(false);
  const [imageCompany, setImageCompany] = useState<string>(
    props.userInfos?.Company?.AvatarFileName || ''
  );
  const [updateImageCompany, setUpdateImageCompany] = useState<boolean>(false);
  const [companyName, setCompanyName] = useState<string>(
    props.userInfos?.Company?.Name || ''
  );
  const [companyPhone, setCompanyPhone] = useState<string>(
    props.userInfos?.Company?.Phone || ''
  );
  const [companyStreetAddress, setCompanyStreetAddress] = useState<string>(
    props.userInfos?.Company?.StreetAddress || ''
  );
  const [companyZip, setCompanyZip] = useState<string>(
    props.userInfos?.Company?.Zip || ''
  );
  const [companyNumber, setCompanyNumber] = useState<number | undefined | null>(
    props.userInfos?.Company?.Number || undefined || null
  );
  const [companyDistrict, setCompanyDistrict] = useState<string>(
    props.userInfos?.Company?.District || ''
  );
  const [companyComplement, setCompanyComplement] = useState<string>(
    props.userInfos?.Company?.Complement || ''
  );
  const [companyCity, setCompanyCity] = useState<string>(
    props.userInfos?.Company?.City || ''
  );
  const [companyState, setCompanyState] = useState<string>(
    props.userInfos?.Company?.State || ''
  );

  const [companyCnpj, setCompanyCnpj] = useState<string>(
    props.userInfos?.Company?.CNPJ || ''
  );
  const [companyOwnerName, setCompanyOwnerName] = useState<string>(
    props.userInfos?.Company?.OwnerName || ''
  );
  const [companyOwnerCpf, setCompanyOwnerCpf] = useState<string>(
    props.userInfos?.Company?.OwnerCPF || ''
  );
  const [companySite, setCompanySite] = useState<string>(
    props.userInfos?.Company?.Site || ''
  );
  const [zipInvalid, setZipInvalid] = useState<string>('');

  const onUploadImageCompany = (uploadedImage: string) => {
    setImageCompany(uploadedImage);
    setUpdateImageCompany(true);
  };

  useEffect(() => {
    setImageCompany(props.userInfos?.Company?.AvatarFileName || '');
  }, [props.userInfos]);

  useEffect(() => {
    setCompanySite(props?.userInfo?.Company?.Site || '')
    setCompanyOwnerCpf(props?.userInfo?.Company?.OwnerCPF || '')
    setCompanyCnpj(props?.userInfo?.Company?.CNPJ || '');
    setCompanyOwnerName(props?.userInfo?.Company?.OwnerName || '')
    setCompanyStreetAddress(props.userInfos?.Company?.StreetAddress || '');
    setCompanyZip(props.userInfos?.Company?.Zip || '');
    setCompanyNumber(props.userInfos?.Company?.Number || undefined || null);
    setCompanyDistrict(props.userInfos?.Company?.District || '');
    setCompanyComplement(props.userInfos?.Company?.Complement || '');
    setCompanyCity(props.userInfos?.Company?.City || '');
    setCompanyState(props.userInfos?.Company?.State || '');
    setCompanyPhone(props.userInfos?.Company?.Phone || '');
    setCompanyName(props.userInfos?.Company?.Name || '');
  }, [props.userInfos]);

  const getFirstInvalidTab = () => {
    if (companyName === '' || companyPhone === '') {
      return '0';
    }
    if (
      companyStreetAddress === '' ||
      companyZip === '' ||
      companyDistrict === '' ||
      companyCity === '' ||
      companyState === ''
    ) {
      return '1';
    }
    return undefined;
  };

  const updateDadosEmpresa = () => {
    setIsSubmited(false);
    const data: IUpdateUserCompanyDataRequest = {
      AvatarFileName:
        imageCompany === ''
          ? ''
          : imageCompany?.substr(imageCompany?.lastIndexOf('/') + 1),
      StreetAddress: companyStreetAddress,
      Zip: companyZip,
      Number: companyNumber || null,
      District: companyDistrict,
      Complement: companyComplement,
      City: companyCity,
      State: companyState,
      Phone: companyPhone,
      Name: companyName,
      CNPJ: companyCnpj,
      OwnerName: companyOwnerName,
      OwnerCPF: companyOwnerCpf,
      Site: companySite,
    };
    dispatch(MinhaContaActions.updateDadosEmpresa(data));
    setUpdateImageCompany(false);
    if (props.onConfirm) {
      props.onConfirm(true);
    }
  };

  const searchNewAddress = async (e: any) => {
    let zipCode = cleanMask(e);
    setCompanyZip(zipCode);

    if (zipCode.length === 8) {
      try {
        const addressResponse = await fetch(`https://viacep.com.br/ws/${zipCode}/json/`);
        const data = await addressResponse.json();
        if (data && !data.erro) {
          setZipInvalid('');
          setCompanyStreetAddress(data.logradouro);
          setCompanyDistrict(data.bairro);
          setCompanyCity(data.localidade);
          setCompanyState(data.uf);
        } else if (data.erro) {
          setZipInvalid(t('updateEmpresa.invalidZip'));
        }
      } catch (err) { }
    }
  };

  const upgradePlanRedirect = (role: number, planOrder: number) => {
    Mixpanel.track({
      name: 'CALL_T0_ACTION',
      props: {
        origin: 'minha-conta',
        originPath: window.location.pathname
      },
      userInfo: props.userInfo,
      currentListTenant: currentTenant,
      tenantIds: tenants && tenants.length > 0
        ? tenants?.map((tenant) => tenant?.TenantId).filter((tenantId) => tenantId !== undefined) as number[]
        : undefined,
    });

    if (role === 1) {
      if (planOrder === 4) {
        window.open(whatsappContactLink);
      } else {
        navigate('/faturamento/planos');
      }

    } else {
      window.open('https://bim.maletadoengenheiro.com.br/seja-premium');
    }
  };

  const buttons = (
    <div>
      <Button height={37} onClick={props.onCancel}>
        <span style={{ padding: '0 20px' }}>{t('updateEmpresa.cancelButton')}</span>
      </Button>
      {tabSelected === '2' ? (
        <Button
          type='primary'
          ispremium="true"
          width={272}
          height={37}
          onClick={() => upgradePlanRedirect(userRole || 0, planOrder || 0)}
        >
          <span style={{ marginRight: '6px' }}>
            <Icon icon="crown" size="xxs" color="cinzaEscuro" />
          </span>
          {isAdmin
            ? t('updateEmpresa.acquireEnterprisePersonal')
            : t('updateEmpresa.acquireEnterpriseCompany')}
        </Button>
      ) : (
        <Button
          type="primary"
          htmlType="submit"
          height={37}
          onClick={() => {
            const invalidTab = getFirstInvalidTab();
            if (invalidTab) {
              setTabSelected(invalidTab);
            }
            setIsSubmited(true);
          }}
          loading={props.isLoading}
        >
          <span style={{ padding: '0 18px' }}>{t('updateEmpresa.updateButton')}</span>
        </Button>
      )}
    </div>
  );

  const tabs = [
    {
      title: t('updateEmpresa.tabBasic'),
      key: '0',
      disable: false,
      forceRender: true,
      children: (
        <div className={styles['boxDadosEmpresa']}>
          <div className={styles['DadosEmpresaLeft']}>
            <UploadAvatar onUploadImage={onUploadImageCompany}>
              {(isLoading: boolean) => (
                <div
                  className={styles['changeImageWrapper']}
                  style={{
                    backgroundImage: imageCompany
                      ? `linear-gradient(rgba(46,163,242, .6), rgba(46,163,242, .6)),
                            url('${process.env.REACT_APP_IMAGE_STORAGE_URL}${imageCompany}')`
                      : ''
                  }}
                >
                  {isLoading ? (
                    <Spin indicator={<LoadingOutlined color="white" style={{ fontSize: 40, color: 'white' }} />} />
                  ) : (
                    <>
                      <Icon color="branco" customSize={19} icon="editarImg" />
                      <span className={styles['changeImageLabel']}>{t('updateEmpresa.changeImage')}</span>
                    </>
                  )}
                </div>
              )}
            </UploadAvatar>
          </div>
          <div className={styles['DadosEmpresaRight']}>
            <div className={styles['boxData']}>
              <Field name="Name" className={styles['fields']} defaultValue={companyName} onInput={setCompanyName} label={t('updateEmpresa.fieldCompanyName')} />
              <Field name="CNPJ" className={styles['fields']} defaultValue={stringToCNPJ(companyCnpj || '')} label={t('updateEmpresa.fieldCnpj')} onInput={setCompanyCnpj} parse={(value) => value && stringToCNPJ(value)} maxLenght={18} />
              <Field name="Phone" className={styles['fields']} defaultValue={stringToPhone(companyPhone)} label={t('updateEmpresa.fieldPhone')} onInput={setCompanyPhone} parse={(value) => value && stringToPhone(value)} maxLenght={15} />
              <Field name="OwnerName" className={styles['fields']} defaultValue={companyOwnerName} onInput={setCompanyOwnerName} label={t('updateEmpresa.fieldOwner')} />
              <Field name="OwnerCPF" className={styles['fields']} defaultValue={stringToCPF(companyOwnerCpf || '')} label={t('updateEmpresa.fieldOwnerCpf')} onInput={setCompanyOwnerCpf} parse={(value) => value && stringToCPF(value)} maxLenght={14} />
              <Field name="Site" className={styles['fields']} defaultValue={companySite || ''} label={t('updateEmpresa.fieldSite')} onInput={setCompanySite} />
            </div>
          </div>
        </div>
      )
    },
    {
      title: t('updateEmpresa.tabAddress'),
      key: '1',
      disable: false,
      forceRender: true,
      children: (
        <div className={styles['boxDadosEmpresa']}>
          <div className={styles['DadosEndereco']}>
            <div className={styles['boxData']}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Field className={styles['fields']} name="StreetAddress" defaultValue={companyStreetAddress} onInput={setCompanyStreetAddress} label={t('updateEmpresa.fieldStreet')} />
                </Col>
              </Row>
              <Row gutter={[8, 8]}>
                <Col span={10}>
                  <Field className={styles['fields']} name="Zip" defaultValue={stringToCEP(companyZip)} onInput={searchNewAddress} label={t('updateEmpresa.fieldZip')} maxLenght={9} outError={zipInvalid} />
                </Col>
                <Col span={7}>
                  <Field className={styles['fields']} name="Number" defaultValue={companyNumber || undefined} onInput={(value) => setCompanyNumber(parseInt(value))} label={t('updateEmpresa.fieldNumber')} />
                </Col>
                <Col span={7}>
                  <Field className={styles['fields']} name="District" defaultValue={companyDistrict} onInput={setCompanyDistrict} label={t('updateEmpresa.fieldDistrict')} />
                </Col>
              </Row>
              <Row gutter={[8, 8]}>
                <Col span={10}>
                  <Field className={styles['fields']} name="Complement" defaultValue={companyComplement} onInput={setCompanyComplement} label={t('updateEmpresa.fieldComplement')} />
                </Col>
                <Col span={7}>
                  <Field className={styles['fields']} name="City" defaultValue={companyCity} onInput={setCompanyCity} label={t('updateEmpresa.fieldCity')} />
                </Col>
                <Col span={7}>
                  <Field className={styles['fields']} name="State" defaultValue={companyState} onInput={setCompanyState} label={t('updateEmpresa.fieldState')} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )
    }
  ];

  if (!isEnterprise) {
    tabs.push({
      title: t('updateEmpresa.tabPersonalization'),
      key: '2',
      disable: false,
      forceRender: false,
      children: (
        <Wrapper>
          <div className="imageWrapper">
            <img src={PlanoAvisoPersonalizationUpgrade} alt={t('updateEmpresa.upgradeImgAlt')} />
          </div>
          <div className={`contentWrapper ${!isStart ? 'contentWrapperPro' : ''}`}>
            <h2>
              {isStart
                ? isAdmin
                  ? t('updateEmpresa.upgradeHeadingFreePersonal')
                  : t('updateEmpresa.upgradeHeadingFreeCompany')
                : isAdmin
                  ? t('updateEmpresa.upgradeHeadingProPersonal')
                  : t('updateEmpresa.upgradeHeadingProCompany')}
            </h2>
            <h3>
              {isAdmin
                ? t('updateEmpresa.upgradeSubheadingPersonal')
                : t('updateEmpresa.upgradeSubheadingCompany')}
            </h3>
            {isStart && (
              <>
                <p>{t('updateEmpresa.enterpriseProvides')}</p>
                <div className="icons-wrapper">
                  <div className="icons-text-wrapper icons-text-margin">
                    <div>
                      <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                      <span>{t('updateEmpresa.feature2d3d')}</span>
                    </div>
                    <div>
                      <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                      <span>{t('updateEmpresa.featureNomenclature')}</span>
                    </div>
                    <div>
                      <Icon icon={'activities'} customSize={16} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                      <span>{t('updateEmpresa.featureActivities')}</span>
                    </div>
                  </div>
                  <div className="icons-text-wrapper">
                    <div>
                      <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} />
                      <span>{t('updateEmpresa.featureUserManagement')}</span>
                    </div>
                    <div>
                      <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} />
                      <span>{t('updateEmpresa.featurePlotting')}</span>
                    </div>
                  </div>
                  <div style={{ marginBottom: 14 }}>&nbsp;</div>
                </div>
              </>
            )}
          </div>
        </Wrapper>
      )
    });
  }

  return (
    <Modal
      title={t('updateEmpresa.modalTitle')}
      footerButtons={buttons}
      visible={props.visible}
      width={800}
      onCancel={props.onCancel}
    >
      <Form
        onSubmit={updateDadosEmpresa}
        isSubmited={isSubmited}
        schema={schema}
        resetForm={true}
        className={styles['form']}
      >
        <Tabs
          tabs={tabs}
          activeKey={tabSelected}
          onTabClick={(key: string) => {
            setTabSelected(key);
          }}
        />
      </Form>
    </Modal>
  );
};

const mapState = (state: IGlobalReducerState) => ({
  ...state.minhaConta,
  userInfo: state.auth.userInfo,
});

const connector = connect(mapState);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & IModal;

export default connector(UpdateEmpresa);
